// Centralised site content for Sunrise Wealth Management
export const SITE = {
  brand: "Sunrise Wealth Management",
  brandShort: "Sunrise",
  domain: "sunrisewealthmanagement.com",
  tagline: "An educational approach to family wealth.",
  heroSubcopy:
    "We put ourselves at the centre of your financial affairs — so that the advice you receive is always in your best interest.",
  founder: {
    name: "Parteek Marwaha",
    title: "Founder & Wealth Management Consultant",
    bio:
      "Parteek is the founder of Sunrise Wealth Management. He has been a Wealth Consultant working with clients to achieve their business and personal financial goals since 2021. As a tax and insurance expert, a real estate investor, and a professional entrepreneur, he understands the needs of emerging affluent Canadian families and individuals — and their desire to build lasting family wealth.",
    photo: "/founder.jpg",
  },
  contact: {
    email: "info@sunrisewealthmanagement.com",
    phone: "437-995-7262",
    address: "Unit 3 — 50 Venture Drive, Scarborough, ON M1B 3E8",
  },
  socials: [
    { label: "Instagram", href: "#", icon: "instagram" },
  ],
  stats: [
    { value: "4", suffix: "+", label: "Years in Wealth Management" },
    { value: "400", suffix: "+", label: "Clients Served" },
    { value: "99", suffix: "%", label: "Client Satisfaction" },
  ],
  approach: [
    {
      step: "01",
      title: "Listen",
      icon: "ear",
      body:
        "Our process begins with truly hearing you. We examine the financial circumstances of each client, ensuring we have a full understanding of your wants and expectations.",
    },
    {
      step: "02",
      title: "Need Analysis",
      icon: "search",
      body:
        "We accurately identify and evaluate your needs, then build a roadmap for short, medium and long-term goals based on your current situation.",
    },
    {
      step: "03",
      title: "Educate",
      icon: "book-open",
      body:
        "Our educational approach lets you understand every plan deeply — the advantages, the disadvantages, the trade-offs. Clients should be educated before any recommendation.",
    },
    {
      step: "04",
      title: "Solution",
      icon: "lightbulb",
      body:
        "We offer step-by-step solutions with assumptions modelled across 5, 10, 15, 30 and 50-year horizons — so you can see exactly where your plan takes you.",
    },
    {
      step: "05",
      title: "Implement",
      icon: "check-circle",
      body:
        "Once you choose your path, we create a detailed implementation plan you can track, and we make sure it goes live only after you're fully satisfied.",
    },
    {
      step: "06",
      title: "Monitor",
      icon: "line-chart",
      body:
        "We monitor your growth and conduct a detailed annual review — updating the strategy whenever life, markets or goals shift.",
    },
  ],
  services: [
    {
      title: "Planning",
      icon: "compass",
      items: [
        "Financial planning",
        "Retirement planning",
        "First home planning",
        "Kids education planning",
        "Income diversification planning",
        "Corporate estate planning",
      ],
    },
    {
      title: "Investments",
      icon: "trending-up",
      items: [
        "TFSA",
        "FHSA",
        "RRSPs",
        "RESPs",
        "Non-registered investments",
        "Tailored investment plans",
      ],
    },
    {
      title: "Risk Management",
      icon: "shield",
      items: [
        "Life & health insurance",
        "Critical illness insurance",
        "AD&D & long-term care",
        "Visitor & super-visa insurance",
        "Mortgage insurance",
        "Funeral insurance",
      ],
    },
    {
      title: "Business Owners & Self-Employed",
      icon: "briefcase",
      items: [
        "Individual pension plans",
        "Group benefits for employees",
        "Tailored disability insurance",
        "Corporate wealth strategies",
        "Business continuation strategies",
      ],
    },
    {
      title: "Tax Saving Strategies",
      icon: "receipt",
      items: [
        "Individual tax saving strategies",
        "Tax-deferred growth",
        "Business tax savings strategies",
      ],
    },
    {
      title: "Wealth & Estate Planning",
      icon: "landmark",
      items: [
        "Wealth management programs",
        "Asset allocation",
        "Investment management",
        "Intergenerational wealth transfer",
        "Wills & trusts",
      ],
    },
  ],
  expertise: [
    {
      title: "Corporate Wealth Strategies",
      body:
        "Tailored plans for business owners — combining tax savings, tax-free growth, wealth management and clear business succession planning.",
    },
    {
      title: "Disability Insurance for Self-Employed",
      body:
        "24-hour coverage that pays monthly benefits if injury, illness or disability keeps you from working — built specifically for the self-employed.",
    },
    {
      title: "Funeral Insurance",
      body:
        "Specialised end-of-life coverage that takes care of final expenses so your family doesn't have to navigate them under stress.",
    },
  ],
  referenceServices: [
    "Mortgage Services",
    "Collateral Loans",
    "Auto Insurance",
    "Home Insurance",
    "Commercial Insurance",
    "Pet Insurance",
  ],
  partners: [
    { name: "TD Asset Management", url: "https://www.google.com/s2/favicons?domain=td.com&sz=128" },
    { name: "RBC Insurance", url: "https://www.google.com/s2/favicons?domain=rbcinsurance.com&sz=128" },
    { name: "BMO", url: "https://www.google.com/s2/favicons?domain=bmo.com&sz=128" },
    { name: "Manulife Financial", url: "https://www.google.com/s2/favicons?domain=manulife.ca&sz=128" },
    { name: "iA Financial Group", url: "https://www.google.com/s2/favicons?domain=ia.ca&sz=128" },
    { name: "ivari", url: "https://www.google.com/s2/favicons?domain=ivari.ca&sz=128" },
    { name: "Equitable Life of Canada", url: "https://www.google.com/s2/favicons?domain=equitable.ca&sz=128" },
    { name: "Canada Protection Plan", url: "https://www.google.com/s2/favicons?domain=cpp.ca&sz=128" },
    { name: "Foresters Financial", url: "https://www.google.com/s2/favicons?domain=foresters.com&sz=128" },
    { name: "Everest Funeral Concierge", url: "https://www.google.com/s2/favicons?domain=everestfuneral.com&sz=128" },
    { name: "Empire Life", url: "https://www.google.com/s2/favicons?domain=empirelife.ca&sz=128" },
    { name: "La Capitale", url: "https://www.google.com/s2/favicons?domain=beneva.ca&sz=128" },
    { name: "B2B Bank", url: "https://www.google.com/s2/favicons?domain=b2bbank.com&sz=128" },
    { name: "Sirius Benefit Plans", url: "https://www.google.com/s2/favicons?domain=siriusbenefits.ca&sz=128" },
    { name: "Franklin Templeton Investments", url: "https://www.google.com/s2/favicons?domain=franklintempleton.ca&sz=128" },
    { name: "4 Pillars", url: "https://www.google.com/s2/favicons?domain=4pillars.ca&sz=128" },
  ],
  testimonials: [
    {
      quote:
        "Parteek didn't sell us a product — he taught us how money actually works. We finally understand our retirement plan and feel completely in control.",
      name: "Aman & Priya S.",
      role: "Family clients · Mississauga",
    },
    {
      quote:
        "As a self-employed consultant, the disability and corporate strategies he set up have given me peace of mind I didn't think was possible.",
      name: "David L.",
      role: "Independent consultant · Toronto",
    },
    {
      quote:
        "What stood out is the educational approach. Every recommendation came with a clear pros and cons breakdown — no pressure, just clarity.",
      name: "Meera K.",
      role: "Physician · North York",
    },
    {
      quote:
        "Our family's intergenerational wealth plan is now mapped out 30 years ahead. Sunrise's annual reviews keep everything on track.",
      name: "The Patel Family",
      role: "Multi-generational clients",
    },
  ],
  team: {
    intro:
      "Start your journey as an independent wealth consultant with us. We will help you become the best version of yourself and provide you all the tools and guidance to thrive in the wealth management industry.",
    expect: [
      "Trainings",
      "Guidance",
      "Knowledge",
      "Field trainings",
      "Tools",
      "Platform",
      "Mentorship",
    ],
    benefits: [
      "Communication skills",
      "Sales & marketing skills",
      "Flexibility in schedule",
      "Part-time / Full-time",
      "Financial freedom",
      "Increase your network",
      "Pathway to become a business owner",
    ],
  },
};
